import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const AssetMobileVersionsContent = /*#__PURE__*/ memo((props)=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "flex size-full flex-col gap-5 bg-white p-5 dark:bg-black",
        ...props
    });
});
AssetMobileVersionsContent.displayName = "AssetMobileVersionsContent";
